const Flickity = require('flickity');

export default () => {

    let sliders = [];
    const icons = document.querySelectorAll('.icons__list');

    window.addEventListener('load', () => {
        if (canInit()) {
            init();
        }
    });

    window.addEventListener('resize', () => {
        if (canInit()) {
            init();
        } else {
            destroy();
        }
    })

    function init()
    {
        if (sliders.length === 0) {
            for (const iconDom of icons) {
                const f = new Flickity(iconDom, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: true,
                    pageDots: false
                });
                sliders.push(f);
            }
        }
    }

    function destroy()
    {
        if (sliders.length !== 0) {
            for (const slider of sliders) {
                slider.destroy();
            }
            sliders.length = 0;
            sliders = [];
        }
    }

    function canInit()
    {
        return window.innerWidth <= 768;
    }

}
